const Error404 = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div>
        <h1>404</h1>
        <p>Page Not Found</p>
      </div>
    </div>
  );
};

export default Error404;
